import {
    MERCHANT_BANK_ACCOUNT_LIST_INITIATED,
    MERCHANT_BANK_ACCOUNT_INITIATED,
    MERCHANT_BANK_ACCOUNT_LOADED,
    MERCHANT_BANK_ACCOUNT_FAILED,
    MERCHANT_BANK_ACCOUNT_LIST_LOADED,
    MERCHANT_BANK_ACCOUNT_COUNT_INITIATED,
    MERCHANT_BANK_ACCOUNT_COUNT_LOADED,
    MERCHANT_BANK_ACCOUNT_COUNT_FAILED,
    MERCHANT_BANK_ACCOUNT_DOC_INITIATED,
    MERCHANT_BANK_ACCOUNT_DOC_LOADED,
    MERCHANT_BANK_ACCOUNT_DOC_FAILED,
    MERCHANT_VIRTUAL_ACCOUNT_INITIATED,
    MERCHANT_VIRTUAL_ACCOUNT_LIST_LOADED,
    MERCHANT_VIRTUAL_ACCOUNT_FAILED

  } from "../actions/MerchantBankAccountsAction";
  
  const initialState = {
    listdata: [],
    data: [],
    virtualAccount : {},
    merchantCount : {
      disable_api_enabled_count : 0,
      freeze_debit_enabled_count : 0,
      total_count : 0,
    },
    doDetails:{
      bankData : {
        date : '',
        text : ''
      },
      kycData : {
        date : '',
        text : ''
      },
      transData : {
        date : '',
        text : ''
      }
    },
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    error: null
  };
  
  const MerchantReducer = (state = initialState, action) => {
    switch (action.type) {
      case MERCHANT_BANK_ACCOUNT_LIST_INITIATED:
        return {
          ...state,
          data : {},
          loading: true,
          error: null,
        };
      case MERCHANT_BANK_ACCOUNT_LIST_LOADED:
        return {
          ...state,
          loading: false,
          data : {},
          listdata: action.payload.data,
          pagination: action.payload.pagination,
        };
      case MERCHANT_BANK_ACCOUNT_INITIATED:
        return { ...state, loading: true, error: null};
      case MERCHANT_BANK_ACCOUNT_LOADED:
        const updatedObj = Object.fromEntries(
            Object.entries(action.payload).map(([key, value]) => [key, value === null ? '' : value])
        );
        return { ...state, loading: false, data: updatedObj };
      case MERCHANT_BANK_ACCOUNT_COUNT_INITIATED:
          return { ...state};
      case MERCHANT_BANK_ACCOUNT_COUNT_LOADED:
          return { ...state, merchantCount: action.payload };
      case MERCHANT_BANK_ACCOUNT_COUNT_FAILED:
          return { ...state };
      case MERCHANT_VIRTUAL_ACCOUNT_INITIATED:
          return { ...state};
      case MERCHANT_VIRTUAL_ACCOUNT_LIST_LOADED:
          return { ...state, virtualAccount: action.payload };
      case MERCHANT_VIRTUAL_ACCOUNT_FAILED:
          return { ...state };
      case MERCHANT_BANK_ACCOUNT_DOC_INITIATED:
          return { ...state};
      case MERCHANT_BANK_ACCOUNT_DOC_LOADED:
          return { ...state, doDetails: action.payload };
      case MERCHANT_BANK_ACCOUNT_DOC_FAILED:
          return { ...state };
      case MERCHANT_BANK_ACCOUNT_FAILED:
          return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default MerchantReducer;